
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceinratnagiri() {



const cardData = {
  keyword: 'Cab Service in Ratnagiri MIDC',
  heading: 'Efficient and Reliable Corporate Cab Services in Ratnagiri MIDC with eTravo',
  headingDescription: 'eTravo provides top-notch corporate cab services in the Ratnagiri MIDC area, catering to the transportation needs of businesses, industries, and employees. Our services focus on punctuality, safety, and comfort, ensuring hassle-free daily commutes and corporate travel solutions. Equipped with modern vehicles and trained drivers, we support businesses in streamlining employee transport and executive travel. Whether it is staff pickups, client meetings, or industrial shuttle services, eTravo ensures a seamless travel experience throughout Ratnagiri MIDC.',

  top: 'Key Industrial Areas and Localities Served in Ratnagiri MIDC',
  topPlaces: [
    {
      title: 'Ratnagiri Industrial Estate',
      description: 'Serving a wide range of manufacturing and processing units with dedicated employee transport services that help reduce commute times and improve punctuality.'
    },
    {
      title: 'Chemical and Pharma Clusters',
      description: 'Specialized cab services meeting the strict timing and hygiene requirements of pharmaceutical and chemical industries.'
    },
    {
      title: 'Portside Logistics Areas',
      description: 'Supporting logistics companies with reliable shuttle services and staff transportation to keep operations running 24/7.'
    },
    {
      title: 'Nearby Residential Zones',
      description: 'Connecting residential areas like Vashi and Dapoli with the industrial hubs of Ratnagiri MIDC, offering safe and timely employee pickups and drop-offs.'
    },
    {
      title: 'Business and Office Parks',
      description: 'Providing corporate cab rentals and business travel solutions for office staff and visiting clients within the industrial area.'
    }
  ],

  services: [
    {
      name: 'Ratnagiri MIDC Corporate Cab Rentals',
      description: 'Flexible corporate cab rental plans tailored to fit the unique needs of companies operating in Ratnagiri MIDC. From daily commutes to long-term monthly rentals, our services ensure efficient, on-time transport for your workforce.'
    },
    {
      name: 'Employee Transport Cab Ratnagiri MIDC',
      description: 'Custom employee transport solutions designed to handle multiple shifts and large teams, ensuring safety, punctuality, and comfort for all workers traveling to and from the industrial zone.'
    },
    {
      name: 'Business Cab Services Ratnagiri MIDC',
      description: 'Professional cab services for business executives, client meetings, and corporate events, ensuring timely and comfortable travel with well-maintained vehicles.'
    },
    {
      name: 'Corporate Staff Cabs Ratnagiri MIDC',
      description: 'Dedicated staff cab services aimed at improving workforce mobility with and exclusive rides, maintaining hygiene and safety protocols across all trips.'
    },
    {
      name: 'Reliable Corporate Cab Service Ratnagiri MIDC',
      description: 'Committed to consistent, safe, and punctual service delivery, our corporate cab fleet is equipped with GPS tracking and driven by experienced chauffeurs.'
    },
    {
      name: 'AC Corporate Cabs Ratnagiri MIDC',
      description: 'Fully air-conditioned vehicles that provide comfortable travel even during the warm coastal climate of Ratnagiri, ensuring a pleasant commute every day.'
    },
    {
      name: 'Staff Pickup and Drop Cab Ratnagiri MIDC',
      description: 'Efficiently managed pickup and drop-off routes to cater to employee needs across different shifts, reducing waiting times and maximizing route efficiency.'
    },
    {
      name: 'Affordable Business Cab Rentals Ratnagiri MIDC',
      description: 'Cost-effective cab rental solutions for small and medium enterprises, offering quality transportation services that fit your budget.'
    },
    {
      name: 'Executive Cab Services Ratnagiri MIDC',
      description: 'Premium services for executives and VIP clients with luxury vehicles, professional drivers, and personalized attention for all business travel requirements.'
    },
    {
      name: 'Monthly Corporate Cab Rentals Ratnagiri MIDC',
      description: 'Monthly rental options designed for companies with continuous transportation needs, providing dedicated vehicles and drivers for hassle-free management.'
    },
    {
      name: 'Industrial Area Employee Transport Ratnagiri MIDC',
      description: 'Specialized transport services tailored for industrial employees, ensuring safe and reliable movement to and from Ratnagiri’s manufacturing hubs.'
    },
    {
      name: 'Corporate Client Cabs Ratnagiri MIDC',
      description: 'Comfortable and timely rides arranged for visiting clients and partners to ensure a positive impression and smooth business operations.'
    },
    {
      name: 'Business Meeting Cabs Ratnagiri MIDC',
      description: 'On-demand cab services designed to support business meetings, corporate events, and client visits within and around the industrial zone.'
    },
    {
      name: 'Ratnagiri Industrial Area Cab Hire',
      description: 'Flexible and short-term cab hire solutions available for project teams, industrial events, and special transportation requirements.'
    },
    {
      name: 'Corporate Shuttle Cabs Ratnagiri MIDC',
      description: 'Regular shuttle services linking key residential neighborhoods with Ratnagiri MIDC, providing affordable and dependable daily commutes for employees.'
    }
  ],

  tableData: [
    ['Ratnagiri MIDC Corporate Cab Rentals', 'Employee Transport Cab Ratnagiri MIDC'],
    ['Business Cab Services Ratnagiri MIDC', 'Corporate Staff Cabs Ratnagiri MIDC'],
    ['Reliable Corporate Cab Service Ratnagiri MIDC', 'AC Corporate Cabs Ratnagiri MIDC'],
    ['Staff Pickup and Drop Cab Ratnagiri MIDC', 'Affordable Business Cab Rentals Ratnagiri MIDC'],
    ['Executive Cab Services Ratnagiri MIDC', 'Monthly Corporate Cab Rentals Ratnagiri MIDC'],
    ['Industrial Area Employee Transport Ratnagiri MIDC', 'Corporate Client Cabs Ratnagiri MIDC'],
    ['Business Meeting Cabs Ratnagiri MIDC', 'Ratnagiri Industrial Area Cab Hire'],
    ['Corporate Shuttle Cabs Ratnagiri MIDC', '']
  ],


"whychoose": [
  {
    "WhyChooseheading": "Tailored Cab Services for Ratnagiri MIDC",
    "WhyChoosedescription": "eTravo provides customized and dependable corporate cab services specifically designed for the industrial zones of Ratnagiri MIDC. Located in a region known for its agro-based, chemical, and port-related industries, Ratnagiri MIDC requires consistent and region-aware transportation solutions. Our services are ideal for companies looking to enhance employee convenience, reduce tardiness, and maintain smooth operational logistics through safe, on-time commutes."
  },
  {
    "WhyChooseheading": "Versatile Vehicle Options to Meet All Corporate Needs",
    "WhyChoosedescription": "Our well-maintained fleet includes sedans, SUVs, and multi-utility vehicles that serve a wide range of corporate travel needs—from employee shuttles and executive transport to multi-point drop services. Each vehicle is equipped with safety features, air-conditioning, and spacious interiors for comfort during long commutes in coastal terrain."
  },
  {
    "WhyChooseheading": "Experienced Local Drivers with Knowledge of Coastal Routes",
    "WhyChoosedescription": "All eTravo drivers operating in Ratnagiri MIDC are experienced and familiar with regional traffic patterns, coastal road conditions, and industrial locations. Their expertise ensures efficient route selection, minimizing travel time and improving employee punctuality even in remote or challenging areas."
  },
  {
    "WhyChooseheading": "Flexible Booking and Shift-Based Scheduling",
    "WhyChoosedescription": "We understand that Ratnagiri’s industries may operate across different shifts. Our flexible booking options—ranging from daily pick-ups to fixed shift transportation and long-term contracts—make it easy for companies to scale transportation according to staffing needs."
  },
  {
    "WhyChooseheading": "Real-Time GPS Tracking and Ride Monitoring",
    "WhyChoosedescription": "All our vehicles are fitted with real-time GPS tracking systems. Employers can monitor rides as they happen, ensuring employee safety, operational transparency, and better coordination in the event of unexpected delays or emergencies."
  },
  {
    "WhyChooseheading": "Accurate Billing and Transparent Invoicing",
    "WhyChoosedescription": "eTravo offers fully digital, itemized monthly invoices with breakdowns of each trip taken—ideal for HR and finance teams managing transportation budgets, tax compliance, and reimbursements with ease and accountability."
  },
  {
    "WhyChooseheading": "Strict Safety & Hygiene Standards",
    "WhyChoosedescription": "Our cabs are sanitized regularly and maintained under strict hygiene standards. Drivers follow safety protocols including health checks, mask-wearing, and vehicle cleanliness—ensuring your employees feel secure on every ride."
  },
  {
    "WhyChooseheading": "Dedicated Corporate Account Management",
    "WhyChoosedescription": "Each corporate client is assigned a dedicated account manager who acts as your single point of contact for managing schedules, responding to queries, and tailoring the transportation solution to your specific business requirements in Ratnagiri MIDC."
  }
]
}

const faqData = [
  [
    {
      question: "Which areas do your services cover in Ratnagiri MIDC?",
      answer: "We provide coverage throughout Ratnagiri MIDC and nearby industrial and port-related areas, ensuring full commuter access to remote and key commercial zones."
    },
    {
      question: "Do you support shift-based transportation planning?",
      answer: "Yes, we offer recurring and shift-based scheduling ideal for factories and plants operating on multi-shift formats."
    },
    {
      question: "Is detailed billing available for corporate accounting?",
      answer: "Absolutely. We provide transparent, GST-compliant invoices with trip-level data to simplify expense reporting and internal audits."
    },
    {
      question: "Are your drivers familiar with coastal and industrial routes?",
      answer: "Yes, our drivers are local to the region and trained to navigate both highway and interior coastal roads with safety and efficiency."
    },
    {
      question: "What measures do you take for passenger safety?",
      answer: "We use GPS-enabled vehicles, conduct regular sanitization, and require drivers to follow all safety and hygiene protocols."
    },
    {
      question: "Do you offer dedicated support for corporate clients?",
      answer: "Yes, every business client receives a dedicated account manager to handle all coordination, support requests, and service customizations."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Ajit Jadhav",
    designation: "Plant Supervisor, Konkan Foods Pvt Ltd",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo has made our shift-based employee travel in Ratnagiri MIDC seamless and dependable. Great service, even in remote areas.”"
  },
  {
    name: "Ms. Meenal Karkhanis",
    designation: "HR Manager, RatnaChem Industries",
    rating: [1, 1, 1, 1, 1],
    text: "“Their professional drivers and dedicated support make eTravo a reliable transport partner for our daily business operations in Ratnagiri MIDC.”"
  }
];




























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Ratnagiri MIDC",
  "image": "https://www.etravo.in/images/keyword/cab-service-ratnagiri-midc.jpg",
  "description": "Reliable and affordable corporate cab service in Ratnagiri MIDC for employee transport, business meetings, and industrial area commutes. Book AC corporate cabs with professional drivers at eTravo.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.83",
    "ratingCount": "6542"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1599",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-ratnagiri-midc"
  }
};






    return (
        <div>
<Helmet>
  <title>Cab Service in Ratnagiri MIDC | Corporate & Staff Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire cab service in Ratnagiri MIDC for corporate staff transport, business meetings, and industrial commutes. Reliable AC corporate cabs by eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/69.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinratnagiri;